module.exports = __webpack_public_path__ + "img/secure.fbc70e91.svg";